import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

// Resets the window (and document) scroll to the top on every route change.
// Fixes the issue where clicking a product from a scrolled listing would load
// the Product page at the footer instead of at the top.
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    try {
      window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    } catch {
      window.scrollTo(0, 0);
    }
    if (document?.documentElement) document.documentElement.scrollTop = 0;
    if (document?.body) document.body.scrollTop = 0;
  }, [pathname]);

  return null;
}
